/**
 * Constants for backend server configuration.
 * These are used to override the direct Gemini connection and instead use the backend proxy.
 */

// Default backend URL - ideally this would be from environment config
export const BACKEND_WS_URL = process.env.REACT_APP_INTERVIEW_PROXY_WS_URL || '';


/**
 * Get a complete WebSocket URL with client ID for the backend
 * @param clientId Unique identifier for the client connection
 * @returns Complete WebSocket URL for the backend
 */
export function getBackendWsUrl(interviewSessionId: string): string {
  // Ensure client ID is valid
  if (!interviewSessionId || typeof interviewSessionId !== 'string' || interviewSessionId.trim() === '') {
    console.warn('[BackendConfig] Invalid client ID, generating fallback ID');
    // Generate a simple fallback ID
    interviewSessionId = `fallback-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  }
  
  // Get the current URL to try, wss = websocket secure
  let baseUrl = 'wss://' + BACKEND_WS_URL;
  if (BACKEND_WS_URL.toLowerCase().includes("localhost")) {
    baseUrl = 'ws://' + BACKEND_WS_URL;
  }
  
  // Normalize URL to ensure it doesn't have trailing slashes
  const normalizedUrl = baseUrl.endsWith('/') ? 
    baseUrl.slice(0, -1) : 
    baseUrl;
  
  // Return full URL with client ID
  return `${normalizedUrl}/${interviewSessionId}`;
}
